export enum VerificationType {
    nationalIdentityDocumentCompleteProfile = 1,
    nationalIdentityDocumentCode = 2,
    nationalIdentityDocumentPhoto = 3,
    nationalIdentityDocumentSelfie = 4,
    otherDocumentCompleteProfile = 5,
    otherDocumentPhoto = 6,
    otherDocumentSelfie = 7,
    companyCompleteProfile = 8,
    companyPowerOfAttorneyDocument = 9,
    companyDocumentPhoto = 10
}
